import { Component, OnInit } from '@angular/core';
import {Observable} from "rxjs";
import {NewSpendingAccountService, SpendingAccount} from "@brightside-web/desktop/feature/spending-account";

@Component({
    selector: 'brightside-web-spending-account-statements',
    templateUrl: './spending-account-statements.component.html',
    styleUrls: ['./spending-account-statements.component.css'],
    standalone: false
})
export class SpendingAccountStatementsComponent implements OnInit {

  currentAccountInfo$: Observable<SpendingAccount | undefined>  = this.spendingSvc.currentAccountInfo;

  constructor(
    private spendingSvc: NewSpendingAccountService,
  ) { }

  ngOnInit(): void {
    this.spendingSvc.getSpendingAccounts();
  }

}
